import { useState, useEffect } from "react";
import Header from "./components/Header";
import Modal from "./components/Modal";
import Button from "./components/Button";
import "./Login.css";

const API = '/api';

export default function Login({ onLogin, onGoHome }) {
  const [isRegister, setIsRegister] = useState(false);
  const [name, setName]             = useState('');
  const [email, setEmail]           = useState('');
  const [password, setPassword]     = useState('');
  const [error, setError]           = useState('');
  const [loading, setLoading]       = useState(false);

  // Forgot password states
  const [showForgot, setShowForgot]       = useState(false);
  const [forgotEmail, setForgotEmail]     = useState('');
  const [forgotMsg, setForgotMsg]         = useState('');
  const [forgotError, setForgotError]     = useState('');
  const [forgotLoading, setForgotLoading] = useState(false);

  useEffect(() => {
    const params   = new URLSearchParams(window.location.search);
    const userData = params.get('user');
    const errorMsg = params.get('error');
    if (userData) {
      try {
        const user = JSON.parse(decodeURIComponent(userData));
        localStorage.setItem('wsncode_user', JSON.stringify(user));
        window.history.replaceState({}, '', window.location.pathname);
        onLogin(user);
      } catch (e) { setError('Login failed!'); }
    }
    if (errorMsg) {
      setError(decodeURIComponent(errorMsg));
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, [onLogin]);

  const handleSubmit = async () => {
    setError('');
    setLoading(true);
    if (!email || !password || (isRegister && !name)) {
      setError('Please fill all fields');
      setLoading(false);
      return;
    }
    try {
      const url  = isRegister ? `${API}/register.php` : `${API}/login.php`;
      const body = isRegister ? { name, email, password } : { email, password };
      const res  = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (data.success) {
        localStorage.setItem('wsncode_user', JSON.stringify(data.user));
        onLogin(data.user);
      } else {
        setError(data.message);
      }
    } catch (err) {
      setError('Connection error!');
    }
    setLoading(false);
  };

  const handleForgotPassword = async () => {
    setForgotError('');
    setForgotMsg('');
    if (!forgotEmail) { setForgotError('Email daalo!'); return; }
    setForgotLoading(true);
    try {
      const res  = await fetch(`${API}/forgot_password.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: forgotEmail })
      });
      const data = await res.json();
      if (data.success) {
        setForgotMsg('✓ Reset link bhej diya! Email check karo.');
      } else {
        setForgotError(data.message || 'Error! Dobara try karo.');
      }
    } catch {
      setForgotError('Connection error!');
    }
    setForgotLoading(false);
  };

  return (
    <div className="auth-page">

      {/* FORGOT PASSWORD MODAL */}
      {showForgot && (
        <Modal
          title="🔑 Reset Password"
          maxWidth={400}
          onClose={() => { setShowForgot(false); setForgotEmail(''); setForgotMsg(''); setForgotError(''); }}
        >
          <p className="forgot-desc">Apna email daalo — hum reset link bhejenge.</p>
          <div className="forgot-field">
            <input
              type="email"
              className="forgot-input"
              placeholder="you@email.com"
              value={forgotEmail}
              onChange={(e) => setForgotEmail(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') handleForgotPassword(); }}
            />
          </div>
          {forgotError && <p className="forgot-error">{forgotError}</p>}
          {forgotMsg   && <p className="forgot-success">{forgotMsg}</p>}
          <Button
            variant="primary"
            style={{ width: '100%' }}
            onClick={handleForgotPassword}
            disabled={forgotLoading}
          >
            {forgotLoading ? 'Bhej raha hoon...' : 'Reset Link Bhejo'}
          </Button>
        </Modal>
      )}

      {/* TOP BAR */}
      <Header onLogoClick={onGoHome} />

      {/* MAIN */}
      <div className="auth-main">

        {/* LEFT — FORM */}
        <div className="auth-left">
          <div className="auth-badge">
            {isRegister ? '🚀 Join WSNCode' : '👋 Welcome back'}
          </div>
          <h1 className="auth-heading">
            {isRegister ? 'Create your account' : 'Log in to WSNCode'}
          </h1>
          <p className="auth-subheading">
            {isRegister
              ? 'Free forever. No credit card needed.'
              : 'Continue coding where you left off.'}
          </p>

          {/* SOCIAL BUTTONS */}
          <a href={`${API}/google_login.php`} className="auth-social-btn google">
            <svg width="18" height="18" viewBox="0 0 48 48">
              <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
              <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
              <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
              <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
            </svg>
            {isRegister ? 'Sign up' : 'Continue'} with Google
          </a>

          <a href={`${API}/github_login.php`} className="auth-social-btn github">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
              <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z"/>
            </svg>
            {isRegister ? 'Sign up' : 'Continue'} with GitHub
          </a>

          <div className="auth-or"><span>OR</span></div>

          {/* FORM */}
          <div className="auth-form">
            {isRegister && (
              <div className="auth-field">
                <label>Your Name</label>
                <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Ahmed Raza" />
              </div>
            )}
            <div className="auth-field">
              <label>{isRegister ? 'Email' : 'Username or Email'}</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" />
            </div>
            <div className="auth-field">
              <label>Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••"
                onKeyDown={(e) => { if (e.key === 'Enter') handleSubmit(); }} />
            </div>
            {error && <p className="auth-error">{error}</p>}
            <Button variant="primary" style={{ width: '100%', marginTop: '4px' }} onClick={handleSubmit} disabled={loading}>
              {loading ? 'Please wait...' : (isRegister ? 'Create Account →' : 'Log In →')}
            </Button>
            {!isRegister && (
              <p className="auth-forgot">
                <button className="auth-forgot-btn" onClick={() => setShowForgot(true)}>
                  Forgot Password?
                </button>
              </p>
            )}
          </div>

          <p className="auth-switch">
            {isRegister ? 'Already have an account?' : "Don't have an account?"}
            <button onClick={() => { setIsRegister(!isRegister); setError(''); }}>
              {isRegister ? ' Log In' : ' Sign up free'}
            </button>
          </p>
        </div>

        {/* DIVIDER */}
        <div className="auth-divider"></div>

        {/* RIGHT PANEL */}
        <div className="auth-right">
          {isRegister ? (
            <div className="auth-plan">
              <div className="auth-plan-badge">FREE PLAN</div>
              <h3 className="auth-plan-title">Everything included,<br/>no cost.</h3>
              <p className="auth-plan-sub">No credit card. No trial. Free forever.</p>
              <div className="auth-plan-items">
                <div className="auth-plan-item available"><span className="plan-check">✓</span> Live Preview Editor</div>
                <div className="auth-plan-item available"><span className="plan-check">✓</span> Save Projects to Cloud</div>
                <div className="auth-plan-item available"><span className="plan-check">✓</span> Syntax Highlighting</div>
                <div className="auth-plan-item available"><span className="plan-check">✓</span> Mobile Friendly</div>
                <div className="auth-plan-item available"><span className="plan-check">✓</span> Google / GitHub Login</div>
                <div className="auth-plan-item available"><span className="plan-check">✓</span> Share Project Links</div>
                <div className="auth-plan-item unavailable"><span className="plan-cross">→</span> Private Projects (Pro)</div>
                <div className="auth-plan-item unavailable"><span className="plan-cross">→</span> No Ads (Pro)</div>
              </div>
              <a href="#pricing" className="auth-plan-upgrade">See Pro Plans →</a>
            </div>
          ) : (
            <div className="auth-plan">
              <div className="auth-plan-badge">WSNCODE</div>
              <h3 className="auth-plan-title">Built for<br/>South Asian Devs.</h3>
              <p className="auth-plan-sub">Fast. Free. No setup needed.</p>
              <div className="auth-plan-items">
                <div className="auth-plan-item available"><span className="plan-check">✓</span> HTML / CSS / JS Editor</div>
                <div className="auth-plan-item available"><span className="plan-check">✓</span> Live Preview</div>
                <div className="auth-plan-item available"><span className="plan-check">✓</span> Save &amp; Load Projects</div>
                <div className="auth-plan-item available"><span className="plan-check">✓</span> Profile Settings</div>
                <div className="auth-plan-item available"><span className="plan-check">✓</span> Google &amp; GitHub Login</div>
                <div className="auth-plan-item available"><span className="plan-check">✓</span> Mobile Friendly</div>
                <div className="auth-plan-item available"><span className="plan-check">✓</span> 100% Free</div>
              </div>
              <div className="auth-plan-flags">🇵🇰 🇮🇳 🇧🇩 🇦🇪 🇸🇦</div>
            </div>
          )}
        </div>

      </div>
    </div>
  );
}